"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { CircleCheck, FileText, Users, Zap } from "lucide-react";
export default function ProcessSteps() {
  const {
    ref: step1Ref,
    isVisible: step1Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: step2Ref,
    isVisible: step2Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: step3Ref,
    isVisible: step3Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: step4Ref,
    isVisible: step4Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const steps = [{
    icon: FileText,
    title: "Project Assessment",
    description: "We analyze your current operations and identify areas for improvement and growth opportunities.",
    ref: step1Ref,
    isVisible: step1Visible,
    delay: "0ms"
  }, {
    icon: Users,
    title: "Strategic Planning",
    description: "Develop a customized roadmap with clear milestones, timelines, and actionable steps forward.",
    ref: step2Ref,
    isVisible: step2Visible,
    delay: "30ms"
  }, {
    icon: Zap,
    title: "Implementation & Support",
    description: "Execute the plan with hands-on assistance, ensuring smooth integration into your workflow.",
    ref: step3Ref,
    isVisible: step3Visible,
    delay: "60ms"
  }, {
    icon: CircleCheck,
    title: "Ongoing Optimization",
    description: "Monitor progress, refine processes, and continuously drive measurable results and efficiency.",
    ref: step4Ref,
    isVisible: step4Visible,
    delay: "90ms"
  }];
  return <section className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-foreground mb-4">
            Our Process
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            A clear, systematic approach to transforming your operations and achieving sustainable growth.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6">
          {steps.map((step, i) => {
          const Icon = step.icon;
          return <div key={i} data-index={i} ref={step.ref} className="group relative" style={{
            opacity: step.isVisible ? 1 : 0,
            transform: step.isVisible ? "translateY(0)" : "translateY(1.25rem)",
            transition: `opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) ${step.delay}, transform 150ms cubic-bezier(0.4, 0, 0.2, 1) ${step.delay}`
          }}>
                <div className="flex items-start gap-6 p-6 rounded-lg border border-border bg-background shadow-soft transition-all duration-[150ms] ease-[cubic-bezier(0.22,1,0.36,1)] hover:shadow-medium hover:-translate-y-0.5">
                  <div className="flex-shrink-0 w-14 h-14 rounded-md bg-primary-light flex items-center justify-center shadow-soft transition-all duration-[150ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.02] group-hover:bg-primary-light/95">
                    <Icon className="w-7 h-7 text-primary" strokeWidth={2} />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-display text-xl font-semibold text-foreground mb-2">
                      {step.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}